import Iframe from "~/components/Iframe";
import { getCommonSliceProps } from "~/external/prismic";
import connectSlice from "~/lib/connectSlice";

function mapSliceToProps(slice: any) {
  const { primary, items } = slice;

  const props = {
    ...getCommonSliceProps(slice),
    script: primary.script,
    title: primary.title,
  };

  return props;
}

export default connectSlice(mapSliceToProps)(Iframe);
